import api from "./instance";

export default {
  getList: () => api.get("/concessions").then(res => res),
  getItemDetail: id => api.get(`/concessions/${id}`).then(res => res),
  getCinemas: () => api.get(`/cinemas?$include=concessions`).then(res => res)
};
